import { useLocation, useParams } from 'react-router-dom'

import { Text } from '@factorialco/deprecated-design-system'
import {
  ProjectManagementProjectsListPageSoftDeleteProjectModalPageDocument,
  ProjectsDataCollectionDocument,
  SoftDeleteProjectDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { LoadingState } from 'modules/project_management/components/LoadingState'
import SoftDeleteProjectModal from 'modules/project_management/components/modals/SoftDeleteModal'

const SoftDeleteProjectModalPage = () => {
  const { projectId } = useParams()
  const { state } = useLocation()
  const { projectName } = state || { projectName: '' }

  const { loading, data } = useQuery(
    ProjectManagementProjectsListPageSoftDeleteProjectModalPageDocument,
    {}
  )

  const [deleteProject, { loading: loadingMutation }] = useMutation(SoftDeleteProjectDocument, {
    extractorFn: (mutationData) =>
      mutationData.projectManagementMutations.softDeleteProjectmanagementProject,
    refetchQueries: [ProjectsDataCollectionDocument],
    awaitRefetchQueries: false,
  })

  const onSubmit = () => {
    track(trackingEvents.projectManagement.projects.deleteProjectSubmit)

    return deleteProject({ variables: { id: String(projectId) } })
  }

  if (loading) return <LoadingState />

  const canDeleteProject = data?.projectManagement._policies.projectSoftDelete.can ?? false

  if (!canDeleteProject) return null

  const description = (
    <Text size="300">
      {i18n.tView('project_management.modals.delete_project.description', {
        project_name: (
          <Text size="300" weight="bold">
            {projectName}
          </Text>
        ),
      })}
    </Text>
  )

  return (
    <SoftDeleteProjectModal
      onSubmit={onSubmit}
      loading={loadingMutation}
      title={i18n.t('project_management.modals.delete_project.title')}
      description={description}
      iconName={'delete-cross'}
      inputLabel={i18n.t('project_management.modals.delete_project.input_label')}
      submitButtonLabel={i18n.t('project_management.modals.delete_project.submit')}
    />
  )
}

export default SoftDeleteProjectModalPage
